'use client';

import React from 'react';
import PlayerKycDetailsContent from '@/app/dashboard/players/kyc/components/kyc-details-content';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setKycDetails } from '@/store/reducers/drawer-content-slice';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';

import { GeneralDrawer } from '@/types/general';

import DrawerTemplate from '../core/drawer-template';

export default function PlayerKycDetailsDrawer(): React.JSX.Element | null {
  const { drawerState } = useAppSelector(getUi);

  const dispatch = useAppDispatch();

  return (
    <DrawerTemplate
      open={drawerState.KYC_DETAILS}
      onClose={() => {
        dispatch(hideDrawerState(GeneralDrawer.KYC_DETAILS));
        dispatch(setKycDetails(null));
      }}
      title="Documents Details"
      width="830px"
    >
      <PlayerKycDetailsContent />
    </DrawerTemplate>
  );
}
